<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-tab-pane name="1" label="分组配置">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
                <clear-cache-apply />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="转盘配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.prizeWheelId">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="贴纸包" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.cardBoxId">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="保险箱" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.insureBoxId">
                    <el-option v-for="item in list[5]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励捆绑包" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rewardBoxId">
                    <el-option v-for="item in list[6]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="精选优惠" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.productBoxId">
                    <el-option v-for="item in list[7]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="投掷" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.diceBoxId">
                    <el-option v-for="item in list[8]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="免费奖励" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.freeRewardId">
                    <el-option v-for="item in list[9]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row :gutter="10" class="mb8">
                <CommonExcel
                  ref="CommonExcelRef2"
                  :import-p="'config:userLabel:import'"
                  :export-p="'config:userLabel:export'"
                  :import-method="importCfg"
                  :export-method="exportCfg"
                />
              </el-row>
            </div>
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="70%">
        <el-table size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="[4,5,6,7,8].includes(type)">
            <el-table-column label="价格" align="center" width="120">
              <Price :limit-type="[1,2,3]" />
            </el-table-column>
            <el-table-column label="限购次数" align="center" width="120">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.limit" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
              </template>
            </el-table-column>
            <el-table-column label="权重" align="center" width="120">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.v" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" :limit-type="limitType[type]" />
              </template>
            </el-table-column>
            <el-table-column v-if="[7].includes(type)" label="网页奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward2" />
              </template>
            </el-table-column>
            <el-table-column v-if="[8].includes(type)" label="首次赠送" align="center">
              <template v-slot:default="scope">
                <el-input-number v-model="scope.row.first_num" :controls="false" :min="1" placeholder="首次赠送" style="width: 80%" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==3">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot:default="{row,$index}"><span> {{ $index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="权重" align="center" width="120">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.v" :controls="false" :min="1" placeholder="权重" style="width: 80%" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" :limit-type="[15,22,65]" :limit-len="1" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==9">
            <el-table-column label="刷新时间(小时)" align="center">
              <template v-slot:default="{row}">
                <el-input-number v-model="row.refresh_time" :controls="false" :min="1" placeholder="刷新时间" />
              </template>
            </el-table-column>
            <el-table-column label="奖励" align="center">
              <template v-slot:default="scope">
                <Reward v-model="scope.row.reward" :limit-type="[15,22,65]" :limit-len="1" />
              </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" width="100">
            <template v-slot:default="{row,$index}">
              <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button :disabled="type === 9 && diaLogList.length > 0" size="small" type="primary" @click="addRewardDialogList(type)">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import {
} from '@/api/config/run-for-money-cfg'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Price from '@/components/Price/index.vue'

export default {
  name: 'TgTurntable',
  components: { Price, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      loading: false,
      dialog: false,
      diaLogList: [],
      total: 0,
      list: [],
      type: 1,
      limitType: { 3: [], 4: [], 5: [], 6: [], 7: [], 8: [15], 9: [] },
      typeArr: { 3: '转盘配置', 4: '贴纸包', 5: '保险箱', 6: '奖励捆绑包', 7: '精选优惠', 8: '投掷', 9: '免费奖励' },
      baseList: [],
      mapDialog: false,
      mapDialogList: [],
      groupsList: [],
      curClass: 'webFb'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
      this.initBase()
    },
    initBase() {
      getCommonCfg({ name: 'tgBaseCfg' }).then(res => {
        if (res.data) {
          this.tgBaseCfg = res.data
        }
      })
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
        getCommonCfg({ name: this.curClass }).then(res => {
          if (res.data) {
            this.baseList = res.data
          }
        })
      })
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    handleSaveBase() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.baseList) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2], goodsId: this.list[3], rechargeId: this.list[4] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = 'webFb配置'
      const hearer = []
      const excelData = []
      const name = ['webFb配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, rewardId: this.list[2], goodsId: this.list[3], rechargeId: this.list[4] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, cardBoxId: '贴纸包', insureBoxId: '保险箱', prizeWheelId: '转盘配置', rewardBoxId: '奖励捆绑包', productBoxId: '精选优惠', diceBoxId: '投掷', freeRewardId: '免费奖励' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id !== 0) {
        delActAuxiliary({ idList: [id] })
      }
      this.list[this.type].splice(index, 1)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            if (this.type !== 4) {
              for (let j = 0; j < excelData[i].sheetData.length; j++) {
                excelData[i].sheetData[j].reward = this.$refs.RewardRef.handleTranToVal(excelData[i].sheetData[j].reward)
              }
            }
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => { this.getList() }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      if (type === 3) {
        fileName = '转盘配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { v: '权重', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      if ([4, 5, 6, 7, 8].type) {
        fileName = '商品配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tranTitle = { mtype: '类型', sku: '库存', bet: '倍数', price: '价格', limit: '限购次数', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}}
          if ([7].includes(type)) {
            tranTitle.reward2 = { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          if ([8].includes(type)) {
            tranTitle.reward2 = { first_num: '首次赠送' }
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, tranTitle)
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      if (type === 9) {
        fileName = '免费配置'
        for (let i = 0; i < dataArr.length; i++) {
          const row = JSON.parse(JSON.stringify(dataArr[i]))
          for (let j = 0; j < row.length; j++) {
            row[j].reward = this.$refs.RewardRef.handleTranToZH(row[j].reward)
          }
          const tAk = this.$refs.CommonExcelRef.makeExcelData(row, { refresh_time: '刷新时间', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}})
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0, freeTime: 0, inviteTime: 0, price: 1 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      let row = { v: 0, reward: [] }
      if (index === 3) {
        row = { price: 1, limit: 1, reward: [] }
      }
      if (index === 4) {
        row = { price: 1, num: 1, type: 1 }
      }
      this.diaLogList.push(row)
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleChangePrice(row) {
      for (let i = 0; i < this.skuList.length; i++) {
        if (row.price === this.skuList[i].price) {
          row.sku = this.skuList[i].sku
          break
        }
      }
    },
    onSubmitBase() {
      updateCommonCfg({ name: 'tgBaseCfg', data: JSON.stringify(this.tgBaseCfg) }).then(res => {
        this.msgSuccess('保存成功')
      })
    }

  }
}
</script>
